export default __webpack_public_path__ + "static/media/giftVer2.0ac97329.png";